import HomeIcon from "@redotech/redo-icons/home-02.svg";
import InboxIcon from "@redotech/redo-icons/inbox-01.svg";
import MessageSquareIcon from "@redotech/redo-icons/message-text-square-02.svg";
import PackageIcon from "@redotech/redo-icons/package.svg";
import ShieldDollarIcon from "@redotech/redo-icons/shield-dollar.svg";
import TruckIcon from "@redotech/redo-icons/truck-01.svg";
import { WalkthroughRegistryEntry } from "@redotech/redo-merchant-app-common/walkthrough/walkthrough-registry-entry";

export const WALKTHROUGH_REGISTRY: WalkthroughRegistryEntry[] = [
  {
    id: "support-v2-list",
    name: "Support inbox",
    Icon: InboxIcon,
    loader: () =>
      import("@redotech/redo-merchant-support-app/v2/walkthrough/list-definition"),
    hideFromPicker: true,
  },
  {
    id: "support-v2-ticket",
    name: "Support ticket",
    Icon: MessageSquareIcon,
    loader: () =>
      import("@redotech/redo-merchant-support-app/v2/walkthrough/ticket-definition"),
    hideFromPicker: true,
  },
  {
    id: "new-home",
    name: "New Home",
    Icon: HomeIcon,
    loader: () => import("../plg-homepage/walkthrough/definition"),
    hideFromPicker: true,
  },
  {
    id: "returns",
    name: "Returns",
    Icon: PackageIcon,
    loader: () => import("../return/walkthrough/definition"),
    mockSourceLoader: () =>
      import("../return/walkthrough/mock-return-fetcher").then((m) => ({
        source: m.mockReturnFetcher,
      })),
    overlayLoader: () =>
      import("../return/walkthrough/walkthrough-return-detail").then((m) => ({
        Component: m.WalkthroughReturnDetail,
      })),
  },
  {
    id: "shipping-ready-to-ship",
    name: "Shipping",
    Icon: TruckIcon,
    loader: () =>
      // redont-allow-dynamic-import: walkthrough definitions load on demand, like the support ones above
      import("@redotech/redo-merchant-fulfillment-app/fulfillment-groups/walkthrough/definition"),
  },
  {
    id: "disputes",
    name: "Disputes",
    Icon: ShieldDollarIcon,
    loader: () => import("../payments/chargebacks/walkthrough/definition"),
    mockSourceLoader: () =>
      import("../payments/chargebacks/walkthrough/mock-source").then((m) => ({
        source: m.disputesWalkthroughSource,
      })),
  },
];
